import React, { Component } from "react";
import ErrorPage from "../ErrorPage/ErrorPage";

class Page404 extends Component {
  render() {
    const error = {
      code: 404,
      title: "Oops! You're lost.",
      message: "The page you are looking for was not found."
    }
    return (
      <ErrorPage history={this.props.history} error={error}/>
    );
  }
}

export default Page404;



// WEBPACK FOOTER //
// ./src/views/Pages/Page404/Page404.js